package com.lightningkite.kiteui.views.direct

import com.lightningkite.kiteui.models.Icon
import com.lightningkite.kiteui.reactive.Action
import com.lightningkite.kiteui.views.RContext

import com.lightningkite.kiteui.views.RViewWithSecondaryAction

expect class Button(context: RContext) : RViewWithSecondaryAction {
    var enabled: Boolean
}

fun Button.onClick(label: String? = null, icon: Icon? = null, action: suspend ()->Unit) {
    this.action = Action(label ?: "Press", icon ?: Icon.send) { action() }
}

fun Button.onLongClick(label: String? = null, icon: Icon? = null, action: suspend () -> Unit) {
    this.secondaryAction = Action(label ?: "Long Press", icon ?: Icon.info) { action() }
}